export default "/static/consultation/ai.png"